import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UsersFetchFailedAction = {
	type: 'USERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UsersFetchFailedAction => ({
	type: 'USERS_FETCH_FAILED',
	payload,
});
